<template>
    <section class="section register-form">
        <div class="ingreso">
            <div class="card">
                <div class="card-content card-confirm">
                    <div class="confirm-icon" v-if="confirmIcon">
                        <svg
                            class="icon-tada icon-tada--animate"
                            viewBox="0 0 35 36"
                            fill="none"
                            fill-rule="evenodd"
                        >
                            <desc>Cañón de confeti</desc>
                            <path
                                class="icon-tada-cone"
                                fill-rule="nonzero"
                                d="M8.945 15.0389c-.3042-.1171-.6083.039-.7223.3514L1.038 34.133c-.076.2343-.038.4686.114.6248.1141.1171.2662.1562.4182.1562.076 0 .152 0 .19-.039l18.2849-7.38c.304-.1171.4181-.4295.342-.7419-1.9006-5.5056-6.0442-9.8008-11.4422-11.7141zm-2.8922 9.243l.7572-1.9786c1.637.7185 3.1093 1.6751 4.4186 2.8707 1.1174 1.0202 2.0807 2.182 2.8904 3.4864l-2.406.9715c-.79-1.1861-1.7072-2.2561-2.7511-3.2093a17.0284 17.0284 0 00-2.9091-2.1407zm-.3589.9378a16.0613 16.0613 0 012.6232 1.948 16.3526 16.3526 0 012.4678 2.839l-8.1883 3.3062 3.0973-8.0932zm1.4713-3.8445l1.9318-5.0478c4.6377 1.8353 8.249 5.5447 10.0357 10.3085l-4.0944 1.6532c-.878-1.4485-1.9333-2.7357-3.1649-3.8602-1.395-1.2737-2.965-2.292-4.7082-3.0537z"
                            />
                            <path
                                class="icon-tada-circle-1"
                                d="M12.0482 9.0818l.0164-.0172C12.3405 8.7888 12.5 8.4044 12.5 8s-.1595-.7888-.4354-1.0646C11.7888 6.6595 11.4044 6.5 11 6.5s-.7888.1595-1.0646.4354C9.6595 7.2112 9.5 7.5956 9.5 8s.1595.7888.4354 1.0646c.2758.2759.6602.4354 1.0646.4354.4361 0 .7987-.1436 1.0482-.4182z"
                            />
                            <path
                                class="icon-tada-circle-2"
                                d="M27 4.5c.4044 0 .7888-.1595 1.0646-.4354.2759-.2758.4354-.6602.4354-1.0646s-.1595-.7888-.4354-1.0646C27.7888 1.6595 27.4044 1.5 27 1.5s-.7888.1595-1.0646.4354C25.6595 2.2112 25.5 2.5956 25.5 3s.1595.7888.4182 1.0482c.3304.3004.6882.4518 1.0818.4518z"
                            />
                            <path
                                class="icon-tada-circle-3"
                                d="M18 33.5c.4044 0 .7888-.1595 1.0646-.4354.2759-.2758.4354-.6602.4354-1.0646s-.1595-.7888-.4354-1.0646C18.7888 30.6595 18.4044 30.5 18 30.5s-.7888.1595-1.0646.4354c-.2759.2758-.4354.6602-.4354 1.0646s.1595.7888.4182 1.0482c.3304.3004.6882.4518 1.0818.4518z"
                            />
                            <path
                                class="icon-tada-circle-4"
                                d="M25 27.5c.4044 0 .7888-.1595 1.0646-.4354.2759-.2758.4354-.6602.4354-1.0646s-.1595-.7888-.4354-1.0646C25.7888 24.6595 25.4044 24.5 25 24.5s-.7888.1595-1.0646.4354c-.2759.2758-.4354.6602-.4354 1.0646s.1595.7888.4182 1.0482c.3304.3004.6882.4518 1.0818.4518z"
                            />
                            <path
                                class="icon-tada-star-1"
                                d="M3.1382 13.926l1.1479-1.318 1.7417.1701-.9194-1.446.7056-1.561-1.7056.4054-1.3231-1.148-.1318 1.718-1.501.8521 1.6087.6407.377 1.6868z"
                            />
                            <path
                                class="icon-tada-star-2"
                                d="M27.9297 32.9061l1.7819-.2379 1.2638 1.2771.2674-1.7005 1.5814-.6949-1.5779-.7899-.2572-1.7383-1.2874 1.2146-1.7439-.3369.8162 1.5134-.8443 1.4933z"
                            />
                            <path
                                class="icon-tada-star-3"
                                d="M29.9961 11.0643l1.5039-.8314 1.5039.8314-.288-1.7655 1.2467-1.2777-1.7203-.2629L31.5 6.1768l-.7423 1.5814-1.7203.2629 1.2467 1.2777-.288 1.7655z"
                            />
                            <path
                                class="icon-tada-streamer-2"
                                d="M20.601 21.659a.0584.0584 0 01.0507.0653.0601.0601 0 01-.0663.053c2.6005.3095 3.7589-.2173 3.143-1.7995-.1916-.4922-.1213-.7186.1564-.8048.2263-.0702.4863-.0614 1.22.053l.0856.0135h0l.085.0133c.6717.105.995.1293 1.2811.0797.4129-.0716.6013-.318.5646-.7364-.1018-1.1597.868-1.8942 3.069-2.1671a.058.058 0 01-.0647-.0508.0605.0605 0 01.0522-.0675c-2.173.2694-3.2875 1.0041-3.174 2.2977.0317.36-.1152.546-.4653.6066-.2657.046-.5482.0286-1.243-.08l-.086-.0134h0l-.0845-.0133c-.6933-.1082-1.0163-.1288-1.273-.0492-.0568-.0017-.0568-.0017-.3187.2686-.0753.1546-.0659.258-.0278.3908.0157.0548-.0065-.0032.1133.3044.5377 1.3813-.3718 1.951-3.0177 1.636z"
                            />
                            <path
                                class="icon-tada-streamer-1"
                                d="M15.4214 14.5034a.0584.0584 0 01.075.0352.0601.0601 0 01-.035.0774c2.4575-.9049 3.2505-1.9001 1.9834-3.0303-.3942-.3515-.4343-.5852-.226-.7881.1697-.1653.4054-.2755 1.1111-.5066l.0824-.0269h0l.0817-.0267c.6462-.2114.9453-.3366 1.1777-.5106.3354-.2512.3914-.5563.1687-.9125-.6172-.987-.0864-2.0818 1.7508-3.3242a.058.058 0 01-.0808-.0158.0605.0605 0 01.0158-.084c-1.8138 1.2267-2.4733 2.3873-1.7848 3.4883.1916.3064.1451.5388-.1393.7518-.2158.1616-.4754.2743-1.1437.493l-.0829.027h0l-.0812.0266c-.667.2183-.964.3466-1.1566.5341-.0515.0243-.0515.0243-.162.384.003.172.0583.2597.1526.3608.0389.0417-.0072.0001.2391.2199 1.1062.9866.5545 1.907-1.946 2.8276z"
                            />
                        </svg>
                    </div>
                    <div class="is-size-3 pt-2 has-text-primary" v-if="title">
                        <h2>{{ title }}</h2>
                    </div>
                    <div>
                        <p class="is-size-4 my-4" v-if="message" v-html="message">
                        </p>
                        <p class="is-size-6 my-4" v-if="info">
                            {{ info }}
                        </p>
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "CardMessage",
    props: {
        title: {
            type: String,
        },
        message: {
            type: String,
        },
        info: {
            type: String,
        },
        confirmIcon: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
